import { Black5IconSrc } from "@/cdn-resources/black5";
import { ChristmasIconSrc } from "@/cdn-resources/christmas";
import { SPRING_ICON } from "@/cdn-resources/spring";
import type {
  IChristmasCategoryItem,
  IHolidayIconType,
} from "@/shared/entitys";
import {
  ChristmasCategoryType,
  HolidayType,
  TrackingChristmasBtnID,
} from "@/shared/enums";

export const ChristmasCategoryList: IChristmasCategoryItem[] = [
  { name: "Holiday Haul", type: ChristmasCategoryType.ChristmasDeals },
  { name: "Super Commission", type: ChristmasCategoryType.SuperCommission },
  {
    name: "Holiday Products Category",
    type: ChristmasCategoryType.Category,
  },
  { name: "More Holiday Products", type: ChristmasCategoryType.More },
];

export const HolidayIcon: Partial<Record<HolidayType, IHolidayIconType>> = {
  [HolidayType.Black5]: {
    iconSrc: Black5IconSrc,
    width: 38,
    height: 28,
  },
  [HolidayType.Christmas]: {
    iconSrc: ChristmasIconSrc,
    width: 65,
    height: 34,
  },
  [HolidayType.Winter]: {
    iconSrc: ChristmasIconSrc,
    width: 65,
    height: 34,
  },
  [HolidayType.Spring]: {
    iconSrc: SPRING_ICON,
    width: 68,
    height: 32,
  },
};

export const TrackChristmasCategory: Record<
  ChristmasCategoryType,
  TrackingChristmasBtnID
> = {
  [ChristmasCategoryType.ChristmasDeals]: TrackingChristmasBtnID.HolidayHaul,
  [ChristmasCategoryType.SuperCommission]:
    TrackingChristmasBtnID.SuperCommission,
  [ChristmasCategoryType.Category]: TrackingChristmasBtnID.Category,
  [ChristmasCategoryType.More]: TrackingChristmasBtnID.More,
  [ChristmasCategoryType.SpecialOffer]: TrackingChristmasBtnID.SpecialOffer,
};
